import { useEffect } from "react";
import { Blocker, useBlocker } from "react-router-dom";

export type CustomBlockerProps = {
  hasUnsavedChanges: boolean,
  title: string,
  message: string
}

export function useCustomBlocker(props: CustomBlockerProps) {
  const blocker: Blocker | undefined = useBlocker(({ currentLocation, nextLocation }) => {
    const shouldBlock = props.hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname;
    return shouldBlock;
  });

  useEffect(() => {
    if (props.hasUnsavedChanges) {
      const onBeforeUnload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = props.message;
        return props.message;
      };

      window.addEventListener("beforeunload", onBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", onBeforeUnload);
      };
    }
  }, [props.hasUnsavedChanges]);

  useEffect(() => {
    if (blocker?.state !== "blocked") {
      return;
    }

    if (window.confirm(props.message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker.state]);
}